import { createUseStyles } from 'react-jss'

import { darkGrey, trafficRedDark, lightGrey, black, trafficGreenDark } from '../../styles/const/colors'
import { defaultBorderRadius, transitionShort } from '../../styles/const/common'
import { fontFamily, fontWeightRegular } from '../../styles/typography'
import { disabled } from '../../styles/common'
import { phonesDown } from '../../styles/const/breakpoints'

export const ghostBgBtnColor = lightGrey

export default createUseStyles(theme => ({
  btn: {
    border: {
      width: 2,
      style: 'solid',
      color: ghostBgBtnColor
    },
    borderRadius: defaultBorderRadius,
    transition: transitionShort,
    fontSize: 14,
    padding: '8px 14px',
    fontWeight: fontWeightRegular,
    cursor: 'pointer',
    color: black,
    backgroundColor: 'white',
    fontFamily: fontFamily,

    '&.btnBlock': {
      width: '100%',
      maxWidth: '100%',
      padding: '14px 25px'
    },

    '&:focus': {
      outline: 'none'
    },

    '&:disabled': {
      extend: disabled,
      '&.ghost': {
        color: lightGrey
      }
    },

    '&.primary': {
      borderColor: theme.brandPrimary
    },

    '&.dark': {
      borderColor: darkGrey
    },

    '&.danger': {
      color: trafficRedDark,
      borderColor: trafficRedDark,
      '&.buttonTouched, &:active': {
        color: 'white',
        backgroundColor: trafficRedDark,
        borderColor: trafficRedDark
      },
      '@media (hover: hover)': {
        '&:hover': {
          color: 'white',
          backgroundColor: trafficRedDark,
          borderColor: trafficRedDark
        }
      }
    },

    '&.success': {
      color: trafficGreenDark,
      borderColor: trafficGreenDark,
      '&.buttonTouched, &:active': {
        color: 'white',
        backgroundColor: trafficGreenDark,
        borderColor: trafficGreenDark
      },
      '@media (hover: hover)': {
        '&:hover': {
          color: 'white',
          backgroundColor: trafficGreenDark,
          borderColor: trafficGreenDark
        }
      }
    },

    '&.solid': {
      backgroundColor: theme.brandPrimaryLight,

      '&.primary': {
        color: theme.brandPrimaryTextContrastColor,
        backgroundColor: theme.brandPrimary,
        borderColor: theme.brandPrimary
      },

      '&.danger': {
        backgroundColor: trafficRedDark,
        color: 'white'
      },

      '&.buttonTouched, &:active': {
        color: darkGrey,
        backgroundColor: theme.brandPrimaryLight,
        borderColor: theme.brandPrimaryLight
      },
      '@media (hover: hover)': {
        '&:hover': {
          backgroundColor: theme.brandPrimaryLight,
          borderColor: theme.brandPrimaryLight
        }
      }
    },

    // ghost is default mode
    '&.ghost': {
      // when text should be colorful ignore setting black color
      color: ({ colorful }) => !colorful && black,

      '@media (hover: hover)': {
        '&:hover': {
          color: black,
          backgroundColor: theme.brandPrimaryLight,
          borderColor: ghostBgBtnColor
        }
      },

      '&.buttonTouched, &:active': {
        color: theme.brandPrimaryTextContrastColor,
        backgroundColor: theme.brandPrimary,
        borderColor: black
      }
    },

    '& .icon': {
      marginLeft: 10
    }
  },

  [`@media screen and (${phonesDown})`]: {
    btn: {
      fontSize: 12,
      height: 32,
      padding: '7px 10px'
    }
  }
}))
